import { useWishlistProducts, useLocalWishlist } from 'hooks';
import { useState, useEffect } from 'react';
import getShopifyData from 'lib/shopify/getShopifyData';
import CardItem from 'components/sections/highlights/cardItem';
import { getShopifyGid } from 'lib/shopify/shopifyGid';
import styles from './cartWishlist.module.scss';

const CartWishlist = ({ globalModules, locale, cart }) => {
  const { wishlistProducts } = useWishlistProducts(locale);
  const { localWishlist } = useLocalWishlist();
  const [products, setProducts] = useState([]);
  const [shopifyData, setShopifyData] = useState([]);
  const { wishlist: localizedTexts } = globalModules;
  const t = key => localizedTexts[key]?.text;

  const filetrProducts = prodArr => {
    const lineItems = cart?.lines?.edges;
    if (!lineItems) return prodArr;

    const filteredProducts = prodArr.filter(product => {
      const productInCart = lineItems.find(
        lineItem =>
          lineItem.node.merchandise?.product?.id ===
          getShopifyGid('Product', product.shopifyData?.variants?.[0].product_id)
      );
      return !productInCart;
    });
    return filteredProducts;
  };

  useEffect(() => {
    if (!wishlistProducts?.length) return;
    const fetchAllProducts = async () => {
      const data = await getShopifyData({ productIds: localWishlist, locale });
      setShopifyData(data);
    };
    fetchAllProducts();
  }, [wishlistProducts]);

  useEffect(() => {
    if (!cart.lines || !wishlistProducts.length) return;
    setProducts(filetrProducts(wishlistProducts));
  }, [wishlistProducts, cart]);

  const findShopifyData = product => {
    if (!shopifyData?.length) return {};
    const id = product.shopifyData?.variants?.[0].product_id;
    const result = shopifyData.find(
      shopifyProduct => shopifyProduct.productId === getShopifyGid('Product', id)
    );
    return result;
  };

  if (!products?.length) return null;

  return (
    <div className={styles.container}>
      <h2 className={styles.header}>{t('title')}</h2>
      <div className={styles.productsContainer}>
        {products?.map((product, index) => (
          <div className={styles.productWrapper} key={product.id}>
            <CardItem
              locale={locale}
              key={product.id}
              itemData={product}
              shopifyProduct={findShopifyData(product)}
              globalModules={globalModules}
              itemIndex={index}
              pageTitle="Cart Wish List"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CartWishlist;
